import { MoonIcon } from "@phosphor-icons/react/Moon";
import { SunIcon } from "@phosphor-icons/react/Sun";
import { MenuSub } from "@freightsimple/ui-core/Menu/Menu";
import { useThemeContext } from "@freightsimple/ui-core/Theme/useThemeContext";
import { NavBarThemeMenuItems } from "./Internal/NavBarThemeMenuItems";

/**
 * "Theme" submenu for the user menu — Light / Dark / System, with a check on
 * the active choice. A submenu rather than hubble's cycle-on-click row because
 * a ui-core Menu closes on select: cycling would cost up to three reopens,
 * where this picks any theme in one click.
 */
export function NavBarThemeMenu() {
  const { resolvedTheme } = useThemeContext();

  return (
    <MenuSub
      trigger="Theme"
      icon={resolvedTheme === "dark" ? MoonIcon : SunIcon}
    >
      <NavBarThemeMenuItems />
    </MenuSub>
  );
}
